











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/partenaire/edit/EditFtp.vue'
import { getDefaultAloPartenaire, AloPartenaire } from '@/models/alo/AloPartenaire'

@Component({
  name: 'ReadConfig',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    partenaire:{
      type:Object,
      default:getDefaultAloPartenaire
    },  
    editable:{ 
      type:Boolean,
      default:true      
    },  
    loginVisible:{ 
      type:Boolean,
      default:true      
    }
    
  }
})
export default class ReadConfig extends Vue {
  
  private partenaire!:AloPartenaire
  private loading!:boolean  
  private editable!:boolean
  private loginVisible!:boolean
  

  edit() { 
    (this.$refs.edit as Edit).edit(this.partenaire)
  }

}
